var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.600098C6.62677 0.600098 2.07842 4.13159 0.549316 9.00014C2.07845 13.8686 6.62677 17.4001 11.9999 17.4001C17.3731 17.4001 21.9215 13.8686 23.4506 9.00005C21.9215 4.13156 17.3731 0.600098 12 0.600098ZM12 13.8001C14.651 13.8001 16.8 11.6511 16.8 9.0001C16.8 6.34913 14.651 4.2001 12 4.2001C9.34903 4.2001 7.2 6.34913 7.2 9.0001C7.2 11.6511 9.34903 13.8001 12 13.8001ZM14.4 9.0001C14.4 10.3256 13.3255 11.4001 12 11.4001C10.6745 11.4001 9.6 10.3256 9.6 9.0001C9.6 7.67461 10.6745 6.6001 12 6.6001C13.3255 6.6001 14.4 7.67461 14.4 9.0001Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEye);
export default __webpack_public_path__ + "static/media/white_eye.2582f5234a0d7748ada855711af38789.svg";
export { ForwardRef as ReactComponent };